/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it


export const onClientEntry = () => {
    const gtmId = process.env.GATSBY_GTM_ID || 'GTM-KMCX3HQ7';

    if (!gtmId) return;

    // Dodanie kodu Google Tag Manager (GTM) do sekcji <head>
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;

    // Kod GTM inicjujący w sekcji <head>
    script.innerHTML = `
        (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
            j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
    `;

    // Dodanie elementu <script> do <head>
    document.head.appendChild(script);

    // Dodanie kodu awaryjnego (noscript) do sekcji <body>
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;

    // Dodanie elementu <noscript> tuż po otwierającym tagu <body>
    document.body.insertAdjacentHTML("afterbegin", noscript.outerHTML);
};